<template>
  <v-dialog
    v-model="show"
  >
    <v-card
      class="mx-auto position-relative"
    >
      <v-card-title class="justify-center title-card-shop-cart">{{ bannerShopCartTitleModalTranslate }}</v-card-title >

      <v-btn
        class="button-close-cart"
        icon
        @click="close()"
      >
        <v-icon
          color="black"
        >
          mdi-close-thick
        </v-icon>
      </v-btn>
      <v-card-text class="my-3 list-cards-shop">
        <div
          v-for="[key, item] in Object.entries(getShopList)"
          :key="key"
        >
          <product-cart-item-block
            :unit_price="item.productUnitPrice"
            :qty="item.qty"
            :commercial-name="item.commercialName"
            :image="item.image"
            :productGuid="key"
            :comment="item.comments"
            :bannerShopCartCommentLabel="bannerShopCartCommentLabel"
            :bannerShopCartTextCommentBtnSave="bannerShopCartTextCommentBtnSave"
            :bannerShopTextProps="bannerShopTextProps"
            @addQty="() => addQtyProduct(key, item)"
            @subtractQty="() => subtractQtyProduct(key, item)"
            @saveComment="({ comment }) => saveCommentChange(key, item, comment)"
          />
          <div class="separator-cart"></div>
        </div>
      </v-card-text>
      <v-card-actions class="d-flex flex-column justify-center card-shop-card-actions pb-5 pt-5">
        <div class="d-flex justify-space-between total-price">
          <div class="font-weight-bold">{{ bannerShopCartTotalTextTranslate }}</div>
          <div class="font-weight-bold">{{ formattedTotalShop }}</div>
        </div>
        <div class="text-center">
          <v-btn
            class="order-btn"
            color="black"
            :style="textBtnStyle"
            large
            @click="onMakeOrder()"
            :disabled="checkIfShopListEmpty || ordering"
            :loading="ordering"
          >
            <span class="mx-5 my-5">{{ bannerShopCartOrderBtnTextTranslate }}</span>
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { MultiLanguageText, TextProps } from '../models';
import ProductCartItemBlock from './ProductCartItemBlock.vue';

export default {
  name: 'shop-cart-popup-block',
  components: { ProductCartItemBlock },
  props: {
    value: Boolean,
    bannerShopCartTotalText: { type: Object, required: true },
    bannerShopTextProps: { type: Object, required: true, default: () => ({}) },
    bannerShopCartCommentLabel: { type: Object, required: true, default: () => ({}) },
    bannerShopCartOrderBtnText: { type: Object, required: true, default: () => ({}) },
    bannerShopCartTextCommentBtnSave: { type: Object, required: true, default: () => ({}) },
    bannerShopCartTitleModal: { type: Object, required: true, default: () => ({}) },
    ordering: { type: Boolean, default: false }
  },
  data() {
    return {
      isOrdering: false,
    };
  },
  computed: {
    ...mapGetters(['getShopList', 'getTotalSumShop', 'selectedLanguage', 'currencySymbol', 'currencyPosition']),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    myBannerShopCartTotalText() {
      return new MultiLanguageText(this.bannerShopCartTotalText);
    },
    myBannerShopCartOrderBtnText() {
      return new MultiLanguageText(this.bannerShopCartOrderBtnText);
    },
    myBannerShopCartTitleModal() {
      return new MultiLanguageText(this.bannerShopCartTitleModal);
    },
    bannerShopCartTitleModalTranslate() {
      return this.myBannerShopCartTitleModal.getText(this.selectedLanguage);
    },
    bannerShopCartOrderBtnTextTranslate() {
      return this.myBannerShopCartOrderBtnText.getText(this.selectedLanguage);
    },
    bannerShopCartTotalTextTranslate() {
      return this.myBannerShopCartTotalText.getText(this.selectedLanguage);
    },
    checkIfShopListEmpty() {
      return Object.keys(this.getShopList).length === 0;
    },
    myShopTextProps() {
      return new TextProps(this.bannerShopTextProps);
    },
    textBtnStyle() {
      return this.myShopTextProps.getStyles();
    },
    formattedTotalShop() {
      let total = this.getTotalSumShop;
      let symbol = this.currencySymbol || '$';
      let position = this.currencyPosition || 'right';
      return position === 'left' ? `${symbol} ${total}` : `${total} ${symbol}`;
    },
  },
  methods: {
    ...mapActions(['subtractShopList', 'addShopList']),
    close() {
      this.$emit('close');
    },
    addQtyProduct(key, item) {
      const qty = item.qty + 1;
      this.addShopList({ ...item, key, qty });
    },
    subtractQtyProduct(key, item) {
      const qty = item.qty - 1;
      if (qty === 0) {
        this.subtractShopList(key);
      } else {
        this.addShopList({ ...item, key, qty });
      }
    },
    saveCommentChange(key, item, comment) {
      this.addShopList({ ...item, key, comments: comment });
    },
    onMakeOrder() {
      if (this.isOrdering) return;
      this.$emit('onOrder');
    }
  }
};
</script>

<style>
.order-btn span {
  width: 100%;
}
.total-price {
  width: 100%;
  margin-bottom: 15px;
  margin-top: 5px;
}
.button-close-cart {
  position: absolute;
  top: 0px;
  right: 0px;
}
.title-card-shop-cart {
  -webkit-box-shadow: 0px 5px 14px -3px rgba(0,0,0,0.52);
  -moz-box-shadow: 0px 5px 14px -3px rgba(0,0,0,0.52);
  box-shadow: 0px 5px 14px -3px rgba(0,0,0,0.52);
}
.card-shop-card-actions {
  -webkit-box-shadow: 0px -5px 14px -3px rgba(0,0,0,0.52);
  -moz-box-shadow: 0px -5px 14px -3px rgba(0,0,0,0.52);
  box-shadow: 0px -5px 14px -3px rgba(0,0,0,0.52);
}
.list-cards-shop {
  max-height: 450px;
  overflow: auto;
}
.separator-cart {
  background-color: rgba(94, 94, 94, 0.35);
  height: 1px;
  margin-top: 20px;
  margin-bottom: 20px;
}
</style>
